import { CheckoutOrderSummaryItemProps } from './checkout-order-summary-item.props';
import { formatCurrency } from '../../../utils';
import LazyLoad from 'react-lazyload';
import React from 'react';
import { CatalogProductVariant } from '@hiwaldo/sdk/interfaces';

export const CheckoutOrderSummaryItemMolecule = (
  props: CheckoutOrderSummaryItemProps
) => {
  const cartVariant = props.cartProductVariant;
  const variant: CatalogProductVariant = cartVariant?.productVariant;

  const price = cartVariant?.linePrice;

  return (
    <div
      data-cy="checkout-order-summary-item-molecule"
      className="flex justify-between items-center my-3"
    >
      <LazyLoad offset={100}>
        <img
          className="image -m-1.5"
          alt={variant?.title}
          src={variant?.assets[0]?.asset.path}
          width={95}
          height={95}
        />
      </LazyLoad>
      <p className="font-waldo-sans w-28 text-base font-semibold md:w-36 md:text-xl">
        {cartVariant.quantity}x {variant?.title}
      </p>
      <div
        className="trash-bin cursor-pointer ml-2"
        onClick={() => props.clearCartProductVariant(variant.id)}
      >
        <LazyLoad offset={100}>
          <img src="/images/icons/trash.svg" alt="Bin" width={15} height={15} />
        </LazyLoad>
      </div>
      <p className="text-base font-semibold text-uppercase text-waldo-sans md:text-xl">
        {formatCurrency(price as number, 2, 2)}
      </p>
    </div>
  );
};
